import React from "react"
import autobind from "class-autobind"
import ScheduleTimeinfoDetailWeekView from "./weekly/ScheduleTimeinfoDetailWeekView"
import ScheduleTimeinfoDetailMonthView from "./monthly/ScheduleTimeinfoDetailMonthView"
import AddShiftDialogForEveryEmployee from "./AddShiftDialogForEveryEmployee"
import AddShiftsDialog from "../add_shift/AddShiftsDialog"
import { ISchedulePatternTemplate, IScheduleDocument, IScheduleDailyTimelineData, IScheduleShift, TimeBarViewType, EDayOfWeek, IClientDocument, IJobDocument, EScheduleListType } from "../../../models"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"
import _ from "lodash"
import { IScheduleBudgetDay } from "../../../models/data/scheduling/ScheduleBudgetDay"
import CloneDayDialog from "../common/CloneDayDialog"
import DelayDayDialog from "../common/DelayDayDialog"
import * as scheduleHelper from "../../../helpers/scheduleHelper"

interface IProps {
    type: EScheduleListType
    schedule: IScheduleDocument
    viewType: TimeBarViewType
    readonly?: boolean
    handleAddPatternTemplates(newPatternTemplates: ISchedulePatternTemplate[]): void
    handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
    handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
    handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, shiftTemplate: IScheduleShift): void
    checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, updateShiftTemplate: IScheduleShift, patternTemplate: ISchedulePatternTemplate): boolean
    handleDeleteTimelineItem(deleteShiftTemplate: IScheduleShift): void
    handleUpdateTimelineItem(item: IScheduleShift): void
    handleAddTimelineItem(addedPatternTemplate: ISchedulePatternTemplate): void
    handleShowTimecardPopup(employeeId: string, referenceDate: Date | string): void
    handleUnAssignEmployee(patternTemplate: ISchedulePatternTemplate): void
    handleDragPatternTemplate(dragDropPatternTemplateId: string, moveUp: number, reorderItems: ISchedulePatternTemplate[]): void
    handleDropPatternTemplate(): void
    handleChangeViewType(viewType: TimeBarViewType, selectedDate: Date | string, cb: Function): void
    handleUpdateDailyBudget(dailyBudget: IScheduleBudgetDay, dayIndex: number): void
    handleClonePatternTemplates(candidateClonePatternTemplates: ISchedulePatternTemplate[]): void
    handleDelay(delayDay: number, delayLength: number, delayNote: string): void
    handleAddAdditionalDay(): void
    handleDeleteEmptyExtraDay(cb: () => void): void

    scheduleJob: IJobDocument
    scheduleClient: IClientDocument

    // if job has start/end date, cannot add out of job date range. for it, we will use this function
    handleAddShiftDisabled?(selectedWeekDay: number): void

    handleAutoAddShifts(shifts: ISchedulePatternTemplate[]): void
}
interface IState {
    openAddShiftDialog: boolean
    patternTemplateForAddShiftTemplate: ISchedulePatternTemplate
    cloneDay: number
    candidateClonePatternTemplates: ISchedulePatternTemplate[]
    delayDay: number
}

export default class ScheduleDetailMonthlyWeeklyView extends React.Component<IProps, IState> {
    private ScheduleTimeinfoDetailWeekView
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddShiftDialog: false,
            patternTemplateForAddShiftTemplate: null,
            cloneDay: -1,
            candidateClonePatternTemplates: [],
            delayDay: -1,
        }
        autobind(this)
    }

    render() {
        const schedule = _.cloneDeep(this.props.schedule)
        schedule.Schedules = schedule.Schedules.filter(i => !i.Deleted)
        return (
            <div>
                {this.props.viewType === "week" ?
                    <ScheduleTimeinfoDetailWeekView
                        ref={item => this.ScheduleTimeinfoDetailWeekView = item}
                        type={this.props.type}
                        schedule={schedule}
                        readonly={this.props.readonly}
                        allowDragDrop={!this.props.readonly}
                        handleAssignEmployee={this.props.handleAssignEmployee}
                        handleUpdateTimelineData={this.props.handleUpdateTimelineData}
                        checkValidateNewTimeline={this.props.checkValidateNewTimeline}
                        handleDeleteTimelineItem={this.props.handleDeleteTimelineItem}
                        handleDeletePatternTemplates={this.props.handleDeletePatternTemplates}
                        handleAddShiftTemplate={patternTemplateForAddShiftTemplate => this.setState({ patternTemplateForAddShiftTemplate })}
                        handleUpdateTimelineItem={this.props.handleUpdateTimelineItem}
                        handleShowTimecardPopup={this.props.handleShowTimecardPopup}
                        handleUnAssignEmployee={this.props.handleUnAssignEmployee}
                        handleDragPatternTemplate={this.props.handleDragPatternTemplate}
                        handleDropPatternTemplate={this.props.handleDropPatternTemplate}
                        handleAddShiftDisabled={this.props.handleAddShiftDisabled}
                        handleAddAdditionalDay={this.props.handleAddAdditionalDay}
                        allowQuickEditTime={!this.props.readonly}
                        handleUpdateDailyBudget={this.props.handleUpdateDailyBudget}
                        handleOpenCloneDialog={(candidateClonePatternTemplates, cloneDay) => this.setState({ candidateClonePatternTemplates, cloneDay })}
                        handleOpenDelayDialog={delayDay => this.setState({ delayDay })}
                        handleDeleteEmptyExtraDay={this.props.handleDeleteEmptyExtraDay}
                        handleAutoAddShifts={this.props.handleAutoAddShifts}
                        scheduleJob={this.props.scheduleJob}
                        scheduleClient={this.props.scheduleClient}
                    /> :
                    <ScheduleTimeinfoDetailMonthView
                        schedule={schedule}
                        handleGoToDayView={selectedDate => {
                            const selectedDay = moment(selectedDate).diff(timeHelper.keepConvertUTCToLocal(schedule.StartDate), "day")
                            this.props.handleChangeViewType("week", selectedDate, () => this.ScheduleTimeinfoDetailWeekView.setState({ selectedDay }))
                        }}
                    />
                }
                {this.state.patternTemplateForAddShiftTemplate &&
                    <AddShiftDialogForEveryEmployee
                        selectedDay={this.ScheduleTimeinfoDetailWeekView.state.selectedDay}
                        scheduleStartDate={timeHelper.keepConvertUTCToLocal(schedule.StartDate)}
                        patternTemplate={this.state.patternTemplateForAddShiftTemplate}
                        handleAddShift={addedPatternTemplate => {
                            this.setState({ patternTemplateForAddShiftTemplate: null })
                            this.props.handleAddTimelineItem(addedPatternTemplate)
                        }}
                        handleClose={() => this.setState({ patternTemplateForAddShiftTemplate: null })}
                        scheduleJob={this.props.scheduleJob}
                        scheduleClient={this.props.scheduleClient}
                    />
                }
                {this.state.openAddShiftDialog &&
                    <AddShiftsDialog
                        selectedDay={this.ScheduleTimeinfoDetailWeekView.state.selectedDay}
                        schedule={schedule}
                        handleClose={() => this.setState({ openAddShiftDialog: false })}
                        handleAddPatternTemplates={patternTemplates => {
                            this.setState({ openAddShiftDialog: false })
                            this.props.handleAddPatternTemplates &&
                                this.props.handleAddPatternTemplates(patternTemplates)
                        }}
                        scheduleJob={this.props.scheduleJob}
                        scheduleClient={this.props.scheduleClient}
                    />
                }
                {this.state.cloneDay > -1 &&
                    <CloneDayDialog
                        isScheduleTemplate={false}
                        scheduleStartDate={timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)}
                        candidateCloneDay={this.state.cloneDay}
                        dayLength={scheduleHelper.getDayLengthFromStartAndEndTime(this.props.schedule.StartDate, this.props.schedule.EndDate)}
                        candidateClonePatternTemplates={this.state.candidateClonePatternTemplates}
                        handleClose={() => this.setState({ cloneDay: -1, candidateClonePatternTemplates: [] })}
                        handleSave={clonePatternTemplates => {
                            this.props.handleClonePatternTemplates(clonePatternTemplates)
                            this.setState({ cloneDay: -1, candidateClonePatternTemplates: [] })
                        }}
                    />
                }
                {this.state.delayDay > -1 &&
                    <DelayDayDialog
                        dayInfo={moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(this.state.delayDay, "day").format("ddd MMM. DD, YYYY")}
                        handleClose={() => this.setState({ delayDay: -1 })}
                        handleDelay={(delayLength, delayNote) => {
                            this.props.handleDelay(this.state.delayDay, delayLength, delayNote)
                            this.setState({ delayDay: -1 })
                        }}
                    />
                }
            </div>
        )
    }
} 